const makeBytesUnitFactory = (power: number) => (bytes: number) =>
  bytes / 1024 ** power;

export const bytesToTB = makeBytesUnitFactory(4);
export const bytesToGB = makeBytesUnitFactory(3);
export const bytesToMB = makeBytesUnitFactory(2);
export const bytesToKB = makeBytesUnitFactory(1);
export const formatByteSize = (bytes: number) => {
  if (bytes < 0) {
    throw new Error('Bytes cannot be negative');
  }

  if (bytes < 1024) {
    return [bytes, 'B'] as [number, 'B' | 'KB' | 'MB' | 'GB' | 'TB'];
  }

  const units = ['B', 'KB', 'MB', 'GB', 'TB'] as const;
  const exponent = Math.min(
    Math.floor(Math.log(bytes) / Math.log(1024)),
    units.length - 1,
  );
  const value = bytes / Math.pow(1024, exponent);

  return [value, units[exponent]] as [number, 'B' | 'KB' | 'MB' | 'GB' | 'TB'];
};
